import React, { useState, useEffect } from 'react';
import { projects } from '../data/mockData';
import { initScrollAnimations } from '../utils/scrollAnimations';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [galleryIndex, setGalleryIndex] = useState(0);

  useEffect(() => {
    initScrollAnimations();
  }, []);

  const openModal = (project) => {
    setSelectedProject(project);
    setGalleryIndex(0);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedProject(null);
    document.body.style.overflow = 'auto';
  };

  const handlePrev = () => {
    setGalleryIndex((prev) => {
      let galleryLength = 20;
      if (selectedProject?.galleryFolder === 'project1') galleryLength = project1Gallery.length;
      if (selectedProject?.galleryFolder === 'project2') galleryLength = project2Gallery.length;
      if (selectedProject?.galleryFolder === 'project3') galleryLength = pirkleGallery.length;
      return prev === 0 ? galleryLength - 1 : prev - 1;
    });
  };
  const handleNext = () => {
    setGalleryIndex((prev) => {
      let galleryLength = 20;
      if (selectedProject?.galleryFolder === 'project1') galleryLength = project1Gallery.length;
      if (selectedProject?.galleryFolder === 'project2') galleryLength = project2Gallery.length;
      if (selectedProject?.galleryFolder === 'project3') galleryLength = pirkleGallery.length;
      return prev === galleryLength - 1 ? 0 : prev + 1;
    });
  };

  const project1Gallery = [
    '6_006 - 448 golden bear pass dahlonega ga.jpg',
    '12_012 - 448 golden bear pass dahlonega ga.jpg',
    '14_014 - 448 golden bear pass dahlonega ga.jpg',
    '19_019 - 448 golden bear pass dahlonega ga.jpg',
    '25_025 - 448 golden bear pass dahlonega ga.jpg',
    '27_027 - 448 golden bear pass dahlonega ga.jpg',
    '29_029 - 448 golden bear pass dahlonega ga.jpg',
    '39_039 - 448 golden bear pass dahlonega ga.jpg',
    '40_040 - 448 golden bear pass dahlonega ga.jpg',
    '42_042 - 448 golden bear pass dahlonega ga.jpg',
    '44_044 - 448 golden bear pass dahlonega ga.jpg',
    '46_046 - 448 golden bear pass dahlonega ga.jpg',
    '50_050 - 448 golden bear pass dahlonega ga.jpg',
    '53_053 - 448 golden bear pass dahlonega ga.jpg',
    '57_057 - 448 golden bear pass dahlonega ga.jpg',
    '59_059 - 448 golden bear pass dahlonega ga.jpg',
    '63_001 - 448 golden bear pass.jpg',
    '70_008 - 448 golden bear pass.jpg',
    '75_013 - 448 golden bear pass.jpg',
    '84_022 - 448 golden bear pass.jpg',
  ];
  // Switch 1st and 18th photo for project1Gallery
  [project1Gallery[0], project1Gallery[17]] = [project1Gallery[17], project1Gallery[0]];
  const project2Gallery = [
    '073_-_39_Cub_Trce_Dahlonega_GA.webp',
    '003 - 39 cub trce dahlonega ga.jpg',
    '006 - 39 cub trce dahlonega ga.jpg',
    '012 - 39 cub trce dahlonega ga.jpg',
    '018 - 39 cub trce dahlonega ga.jpg',
    '020 - 39 cub trce dahlonega ga.jpg',
    '022 - 39 cub trce dahlonega ga.jpg',
    '024 - 39 cub trce dahlonega ga.jpg',
    '026 - 39 cub trce dahlonega ga.jpg',
    '028 - 39 cub trce dahlonega ga.jpg',
    '034 - 39 cub trce dahlonega ga.jpg',
    '036 - 39 cub trce dahlonega ga.jpg',
    '039 - 39 cub trce dahlonega ga.jpg',
    '049 - 39 cub trce dahlonega ga.jpg',
    '059 - 39 cub trce dahlonega ga.jpg',
    '061 - 39 cub trce dahlonega ga.jpg',
    '062 - 39 cub trce dahlonega ga.jpg',
    '063 - 39 cub trce dahlonega ga.jpg',
    '070 - 39 cub trce dahlonega ga.jpg',
    '080 - 39 cub trce dahlonega ga.jpg',
  ];
  const pirkleGallery = [
    '001 - 445 pirkle ave drone.jpg',
    '001 - 445 pirkle ave twilight.jpg',
    '003 - 445 pirkle ave twilight.jpg',
    '005 - 445 pirkle ave buford ga.jpg',
    '008 - 445 pirkle ave buford ga.jpg',
    '010 - 445 pirkle ave buford ga.jpg',
    '010 - 445 pirkle ave twilight.jpg',
    '011 - 445 pirkle ave twilight.jpg',
    '013 - 445 pirkle ave buford ga.jpg',
    '013 - 445 pirkle ave twilight.jpg',
    '014 - 445 pirkle ave buford ga.jpg',
    '018 - 445 pirkle ave buford ga.jpg',
    '021 - 445 pirkle ave buford ga.jpg',
    '023 - 445 pirkle ave buford ga.jpg',
    '025 - 445 pirkle ave buford ga.jpg',
    '041 - 445 pirkle ave buford ga.jpg',
    '054 - 445 pirkle ave buford ga.jpg',
    '055 - 445 pirkle ave buford ga.jpg',
    '060 - 445 pirkle ave buford ga.jpg',
    '065 - 445 pirkle ave buford ga.jpg',
  ];
  // Switch 1st and 3rd photo for pirkleGallery
  [pirkleGallery[0], pirkleGallery[2]] = [pirkleGallery[2], pirkleGallery[0]];

  return (
    <div className="projects-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title animate-on-scroll">Our Projects</h1>
          <p className="page-subtitle animate-on-scroll">
            Explore our portfolio of custom luxury homes, each designed and built with meticulous attention to detail and craftsmanship.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {/* Projects Grid */}
          <div className="grid grid-3">
            {projects.map((project, index) => (
              <div 
                key={project.id} 
                className={`project-card animate-on-scroll ${index % 3 === 0 ? 'slide-left' : index % 3 === 1 ? 'scale-in' : 'slide-right'}`}
                onClick={() => openModal(project)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="project-image-container">
                  <img src={project.image} alt={project.title} className="project-image" />
                  <div className="project-hover-overlay">
                    <div className="hover-content" style={{ color: '#fff' }}>
                      <h3 style={{ color: '#fff' }}>{project.title}</h3>
                      <p style={{ color: '#fff' }}>Click to view details</p>
                    </div>
                  </div>
                </div>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>
                  <div className="project-meta">
                    <span className="project-category">{project.category}</span>
                    <span className="project-size">{project.size}</span>
                  </div>
                  <div className="project-year">Completed: {project.completed}</div>
                </div>
              </div>
            ))}
          </div>

          {projects.length === 0 && (
            <div className="no-projects animate-on-scroll">
              <p>No projects found.</p>
            </div>
          )}
        </div>
      </section>

      {/* Project Modal */}
      {selectedProject && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <div className="modal-grid">
              <div className="modal-image" style={{ position: 'relative', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh', minHeight: '400px', width: '100%' }}>
                {selectedProject.galleryFolder === 'project1' ? (
                  <>
                    <button
                      onClick={handlePrev}
                      style={{
                        position: 'absolute',
                        left: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Previous image"
                    >
                      &#8592;
                    </button>
                    <div style={{
                      width: '100%',
                      height: '100%',
                      minHeight: '100%',
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 100%)',
                      padding: '32px 24px 24px 24px',
                      boxSizing: 'border-box',
                    }}>
                      <div style={{
                        width: '100%',
                        textAlign: 'center',
                        fontWeight: 700,
                        fontSize: 32,
                        color: '#b8956d',
                        letterSpacing: '1px',
                        marginBottom: 32, // Increased space below title
                        marginTop: 16, // Added space above title
                        fontFamily: 'Playfair Display, serif',
                        textShadow: '0 2px 8px rgba(0,0,0,0.25)',
                        position: 'relative',
                      }}>
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '0 auto 16px auto',
                          borderRadius: 2,
                        }} />
                        Photo Gallery
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '16px auto 0 auto',
                          borderRadius: 2,
                        }} />
                      </div>
                      <img
                        src={`/project1/${project1Gallery[galleryIndex]}`}
                        alt={`${selectedProject.title} Gallery ${galleryIndex + 1}`}
                        style={{ width: '100%', height: 'auto', borderRadius: 12, display: 'block', objectFit: 'contain', maxHeight: '70vh', background: 'transparent' }}
                      />
                      <div
                        style={{
                          marginTop: 40, // Increased space above counter
                          color: '#b8956d',
                          fontSize: 28,
                          fontWeight: 700,
                          width: '100%',
                          textAlign: 'center',
                          padding: '16px 0',
                          letterSpacing: '1px',
                          background: 'rgba(26,35,50,0.85)',
                          borderRadius: 8,
                          boxSizing: 'border-box',
                          display: 'block',
                          fontFamily: 'Playfair Display, serif',
                        }}
                      >
                        {galleryIndex + 1} <span style={{ fontWeight: 700 }}>/ {project1Gallery.length}</span>
                      </div>
                    </div>
                    <button
                      onClick={handleNext}
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Next image"
                    >
                      &#8594;
                    </button>
                  </>
                ) : selectedProject.galleryFolder === 'project2' ? (
                  <>
                    <button
                      onClick={handlePrev}
                      style={{
                        position: 'absolute',
                        left: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Previous image"
                    >
                      &#8592;
                    </button>
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 100%)',
                      borderRadius: 16,
                      padding: '32px 24px 24px 24px',
                      boxSizing: 'border-box',
                    }}>
                      <div style={{
                        width: '100%',
                        textAlign: 'center',
                        fontWeight: 700,
                        fontSize: 32,
                        color: '#b8956d',
                        letterSpacing: '1px',
                        marginBottom: 32,
                        marginTop: 16,
                        fontFamily: 'Playfair Display, serif',
                        textShadow: '0 2px 8px rgba(0,0,0,0.25)',
                        position: 'relative',
                      }}>
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '0 auto 16px auto',
                          borderRadius: 2,
                        }} />
                        Photo Gallery
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '16px auto 0 auto',
                          borderRadius: 2,
                        }} />
                      </div>
                      <img
                        src={`/project2/${project2Gallery[galleryIndex]}`}
                        alt={`${selectedProject.title} Gallery ${galleryIndex + 1}`}
                        style={{ width: '100%', height: 'auto', borderRadius: 12, display: 'block', objectFit: 'contain', maxHeight: '70vh', background: 'transparent' }}
                      />
                      <div
                        style={{
                          marginTop: 40,
                          color: '#b8956d',
                          fontSize: 28,
                          fontWeight: 700,
                          width: '100%',
                          textAlign: 'center',
                          padding: '16px 0',
                          letterSpacing: '1px',
                          background: 'rgba(26,35,50,0.85)',
                          borderRadius: 8,
                          boxSizing: 'border-box',
                          display: 'block',
                          fontFamily: 'Playfair Display, serif',
                        }}
                      >
                        {galleryIndex + 1} <span style={{ fontWeight: 700 }}>/ {project2Gallery.length}</span>
                      </div>
                    </div>
                    <button
                      onClick={handleNext}
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Next image"
                    >
                      &#8594;
                    </button>
                  </>
                ) : selectedProject.galleryFolder === 'project3' ? (
                  <>
                    <button
                      onClick={handlePrev}
                      style={{
                        position: 'absolute',
                        left: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Previous image"
                    >
                      &#8592;
                    </button>
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 100%)',
                      borderRadius: 16,
                      padding: '32px 24px 24px 24px',
                      boxSizing: 'border-box',
                    }}>
                      <div style={{
                        width: '100%',
                        textAlign: 'center',
                        fontWeight: 700,
                        fontSize: 32,
                        color: '#b8956d',
                        letterSpacing: '1px',
                        marginBottom: 32,
                        marginTop: 16,
                        fontFamily: 'Playfair Display, serif',
                        textShadow: '0 2px 8px rgba(0,0,0,0.25)',
                        position: 'relative',
                      }}>
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '0 auto 16px auto',
                          borderRadius: 2,
                        }} />
                        Photo Gallery
                        <div className="modal-gallery-divider" style={{
                          width: '60%',
                          height: 2,
                          background: 'linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%)',
                          margin: '16px auto 0 auto',
                          borderRadius: 2,
                        }} />
                      </div>
                      <img
                        src={`/project3/${pirkleGallery[galleryIndex]}`}
                        alt={`${selectedProject.title} Gallery ${galleryIndex + 1}`}
                        style={{ width: '100%', height: 'auto', borderRadius: 12, display: 'block', objectFit: 'contain', maxHeight: '70vh', background: 'transparent' }}
                      />
                      <div
                        style={{
                          marginTop: 40,
                          color: '#b8956d',
                          fontSize: 28,
                          fontWeight: 700,
                          width: '100%',
                          textAlign: 'center',
                          padding: '16px 0',
                          letterSpacing: '1px',
                          background: 'rgba(26,35,50,0.85)',
                          borderRadius: 8,
                          boxSizing: 'border-box',
                          display: 'block',
                          fontFamily: 'Playfair Display, serif',
                        }}
                      >
                        {galleryIndex + 1} <span style={{ fontWeight: 700 }}>/ {pirkleGallery.length}</span>
                      </div>
                    </div>
                    <button
                      onClick={handleNext}
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Next image"
                    >
                      &#8594;
                    </button>
                  </>
                ) : selectedProject.galleryFolder ? (
                  <>
                    <button
                      onClick={handlePrev}
                      style={{
                        position: 'absolute',
                        left: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Previous image"
                    >
                      &#8592;
                    </button>
                    <img
                      src={`/${selectedProject.galleryFolder}/${galleryIndex + 1}.png`}
                      alt={`${selectedProject.title} Gallery ${galleryIndex + 1}`}
                      style={{ maxWidth: '100%', height: 'auto', borderRadius: 12, display: 'block', margin: '0 auto' }}
                    />
                    <button
                      onClick={handleNext}
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                      aria-label="Next image"
                    >
                      &#8594;
                    </button>
                    <div style={{ marginTop: 8, color: '#888', fontSize: 14 }}>
                      {galleryIndex + 1} / 20
                    </div>
                  </>
                ) : (
                <img src={selectedProject.image} alt={selectedProject.title} />
                )}
              </div>
              <div className="modal-info">
                <h2 className="modal-title">{selectedProject.title}</h2>
                <p className="modal-description">{selectedProject.description}</p>
                <div className="modal-details">
                  <div className="detail-item">
                    <span className="detail-label">Size:</span>
                    <span className="detail-value">{selectedProject.size}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Completed:</span>
                    <span className="detail-value">{selectedProject.completed}</span>
                  </div>
                </div>
                <div className="modal-features">
                  {selectedProject.features && (
                    <>
                      <h4>Project Features:</h4>
                      <ul>
                        {selectedProject.features.map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .projects-page {
          padding-top: 80px;
        }

        .page-header {
          background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
          background-size: 400% 400%;
          animation: gradient-shift 8s ease infinite;
          color: var(--white);
          padding: 100px 0;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .page-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill="%23ffffff" fill-opacity="0.1"><circle cx="30" cy="30" r="4"/></g></g></svg>');
          opacity: 0.3;
          animation: float 20s ease-in-out infinite;
        }

        .page-title {
          font-size: 3.5rem;
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
          background: linear-gradient(135deg, var(--white) 0%, var(--light-gold) 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-size: 200% 200%;
          animation: gradient-shift 3s ease infinite;
        }

        .page-subtitle {
          font-size: 1.25rem;
          color: var(--light-blue);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .filter-container {
          text-align: center;
          margin-bottom: 60px;
        }

        .filter-title {
          font-size: 1.75rem;
          color: var(--primary-blue);
          margin-bottom: 30px;
          font-family: 'Playfair Display', serif;
          position: relative;
        }

        .filter-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: linear-gradient(135deg, var(--gold-accent), var(--light-gold));
          border-radius: 2px;
        }

        .filter-buttons {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .filter-btn {
          padding: 15px 28px;
          border: 2px solid var(--primary-blue);
          background: transparent;
          color: var(--primary-blue);
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          animation: slideInUp 0.6s ease-out both;
        }

        .filter-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(217, 119, 6, 0.2), transparent);
          transition: left 0.5s;
        }

        .filter-btn:hover::before {
          left: 100%;
        }

        .filter-btn:hover,
        .filter-btn.active {
          background: var(--primary-blue);
          color: var(--white);
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 10px 25px rgba(30, 58, 138, 0.3);
        }

        .filter-btn.active {
          background: linear-gradient(135deg, var(--gold-accent), var(--light-gold));
          border-color: var(--gold-accent);
          animation: pulse-glow 2s infinite;
        }

        .project-card {
          background: var(--white);
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          transform-style: preserve-3d;
          position: relative;
        }

        .project-card:hover {
          transform: translateY(-20px) rotateY(5deg) rotateX(5deg);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
        }

        .project-image-container {
          position: relative;
          overflow: hidden;
        }

        .project-image {
          width: 100%;
          height: 280px;
          object-fit: cover;
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .project-card:hover .project-image {
          transform: scale(1.15) rotate(3deg);
        }

        .project-hover-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(30, 58, 138, 0.9), rgba(217, 119, 6, 0.9));
          opacity: 0;
          transition: opacity 0.4s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(5px);
        }

        .project-card:hover .project-hover-overlay {
          opacity: 1;
        }

        .hover-content {
          text-align: center;
          color: var(--white);
          transform: translateY(20px);
          transition: transform 0.3s ease 0.1s;
        }

        .project-card:hover .hover-content {
          transform: translateY(0);
        }

        .hover-content h3 {
          font-size: 1.5rem;
          margin-bottom: 10px;
          font-family: 'Playfair Display', serif;
        }

        .project-info {
          padding: 30px;
          position: relative;
        }

        .project-info::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--gold-accent), var(--light-gold));
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .project-card:hover .project-info::before {
          transform: scaleX(1);
        }

        .project-title {
          font-size: 1.5rem;
          color: var(--primary-blue);
          margin-bottom: 12px;
          font-family: 'Playfair Display', serif;
          transition: color 0.3s ease;
        }

        .project-card:hover .project-title {
          color: var(--gold-accent);
        }

        .project-description {
          color: var(--text-light);
          line-height: 1.6;
          margin-bottom: 18px;
          transition: color 0.3s ease;
        }

        .project-card:hover .project-description {
          color: var(--text-dark);
        }

        .project-meta {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          font-weight: 600;
        }

        .project-category {
          color: var(--gold-accent);
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .project-size {
          color: var(--text-dark);
          font-size: 0.9rem;
        }

        .project-year {
          font-size: 0.875rem;
          color: var(--text-muted);
          font-style: italic;
        }

        .no-projects {
          text-align: center;
          padding: 80px 0;
          color: var(--text-light);
          font-size: 1.125rem;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 20px;
          backdrop-filter: blur(10px);
          animation: slideInUp 0.3s ease-out;
        }

        .modal-content {
          background: var(--white);
          border-radius: 20px;
          max-width: 1000px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          animation: scaleIn 0.3s ease-out;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .modal-close {
          position: absolute;
          top: 25px;
          right: 30px;
          background: none;
          border: none;
          font-size: 2.5rem;
          cursor: pointer;
          color: var(--text-dark);
          z-index: 1;
          transition: all 0.3s ease;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }

        .modal-close:hover {
          background: var(--gold-accent);
          color: var(--white);
          transform: rotate(90deg);
        }

        .modal-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0;
        }

        .modal-image {
          position: relative;
          overflow: hidden;
          background: #0a0f1a; /* Full dark background for left half */
        }

        .modal-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .modal-content:hover .modal-image img {
          transform: scale(1.05);
        }

        .modal-info {
          padding: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .modal-title {
          font-size: 2.5rem;
          color: var(--primary-blue);
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
        }

        .modal-description {
          color: var(--text-light);
          line-height: 1.7;
          margin-bottom: 35px;
          font-size: 1.125rem;
        }

        .modal-details {
          margin-bottom: 35px;
        }

        .detail-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          padding: 12px 0;
          border-bottom: 1px solid rgba(217, 119, 6, 0.1);
          transition: all 0.3s ease;
        }

        .detail-item:hover {
          background: rgba(217, 119, 6, 0.05);
          padding: 12px 15px;
          border-radius: 8px;
        }

        .detail-label {
          font-weight: 600;
          color: var(--text-dark);
        }

        .detail-value {
          color: var(--gold-accent);
          font-weight: 600;
        }

        .modal-features h4 {
          color: var(--primary-blue);
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
          font-size: 1.25rem;
        }

        .modal-features ul {
          list-style: none;
          padding: 0;
        }

        .modal-features li {
          padding: 10px 0;
          color: var(--text-light);
          position: relative;
          padding-left: 25px;
          transition: all 0.3s ease;
        }

        .modal-features li:hover {
          color: var(--text-dark);
          transform: translateX(5px);
        }

        .modal-features li::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: var(--gold-accent);
          font-weight: 700;
          font-size: 1.1rem;
        }

        .modal-gallery-divider {
          width: 60%;
          height: 2px;
          background: linear-gradient(90deg, rgba(184,149,109,0.25) 0%, #b8956d 50%, rgba(184,149,109,0.25) 100%);
          margin: 0 auto;
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          .page-title {
            font-size: 2.5rem;
          }

          .modal-grid {
            grid-template-columns: 1fr;
          }

          .modal-info {
            padding: 30px 25px;
          }

          .filter-buttons {
            flex-direction: column;
            align-items: center;
          }

          .project-card:hover {
            transform: translateY(-15px);
          }
        }
      `}</style>
    </div>
  );
};

export default Projects;